import { render, staticRenderFns } from "./MilestoneGroup.vue?vue&type=template&id=c1518ca2&"
import script from "./MilestoneGroup.vue?vue&type=script&lang=js&"
export * from "./MilestoneGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports